import React, { Component } from "react";
// import {Input,Button,Container,Row,Col,Card,CardBody} from 'mdbreact';
import axios from "axios";
import { AuthConsumer } from "./AuthContext";
import domain from "./domain";
// import {Link} from 'react-router-dom'
import swal from "sweetalert";
import { Button, Form, Grid, Segment } from "semantic-ui-react";

import ReactHTMLParser from "react-html-parser";
/**
 * Employee Login  Component
 */
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: " ",
      password: " ",
      captchImage: null,
      captcha: null,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    // this.Auth = new AuthService();
    // this.Input = React.createRef()
  }
  getCaptcha = () => {
    let url = `${domain.DBServer}/captcha_2`;
    return axios
      .get(url, {
        // responseType: 'arraybuffer'
      })
      .then((response) => {
        if (response) {
          this.setState({
            captchImage: response.data,
          });
        }
      });
  };
  componentDidMount() {
    this.getCaptcha();
  }

  onSubmit = (login) => (e) => {
    e.preventDefault();

    const data = {
      username: this.state.username,
      password: this.state.password,
      captcha: this.state.captcha,
    };
    //   console.log(data)
    axios({
      method: "post",
      url: `${domain.DBServer}/login`,
      data: data,
      config: { headers: { "Content-Type": "multipart/form-data" } },
    })
      .then((response) => {
        if (response) {
          if (response.data.success) {
            localStorage.setItem("token", response.data.token);
            // const {id,username,}= decode(localStorage.getItem('token'));

            login();
            swal({
              title: response.data.title,
              text: response.data.msg,
              icon: "success",
            });
            // console.log(this.props)
            this.props.history.goBack();
            // if(username!=='wrgnhp')
            // {
            //     this.props.history.replace(`/profile/${id}`)
            // }
            // else
            // {
            //     this.props.history.replace(`/admin-profile/${id}`)
            // }
          } else {
            swal({
              title: response.data.title,
              text: response.data.err,
              icon: "error",
            });
            return false;
          }

          //console.log(response.data);
        }
      })
      .catch(function (response) {
        //handle error
        console.log(response);
      });
  };

  handleInputChange(e) {
    const target = e.target;
    const name = target.name;
    const value = target.value;
    // console.log(value)
    this.setState({
      [name]: value,
    });
  }
  handleRefresh = () => {
    console.log("here");
    this.getCaptcha();
  };

  render() {
    return (
      <Grid textAlign="center" style={{ height: "100vh" }}>
        <Grid.Column style={{ maxWidth: 450 }}>
          <AuthConsumer>
            {(value) => (
              <Form
                size="large"
                onSubmit={this.onSubmit(
                  value.login,
                  value.getToken,
                  value.getProfile
                )}
              >
                <Segment stacked>
                  <Form.Input
                    fluid
                    icon="user"
                    label="Username"
                    iconPosition="left"
                    placeholder="username"
                    onChange={this.handleInputChange}
                    validate={true}
                    name="username"
                    autoFocus={true}
                    required={true}
                  />
                  <Form.Input
                    fluid
                    icon="lock"
                    iconPosition="left"
                    label="Password"
                    placeholder="Password"
                    validate={true}
                    type="password"
                    onChange={this.handleInputChange}
                    name="password"
                    required={true}
                  />
                  {ReactHTMLParser(this.state.captchImage)}
                  <img
                    alt="svgImg"
                    src="data:image/svg+xml;base64,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"
                    onClick={this.handleRefresh}
                  />
                  <Form.Input
                    label="CAPTCHA"
                    id="captcha"
                    name="captcha"
                    type="text"
                    validate={true}
                    onChange={this.handleInputChange}
                    required={true}
                  />
                  {/* <Link to='/forgot-password'>Forgot Password</Link> */}
                  <Button color="teal" fluid size="large">
                    Login
                  </Button>
                </Segment>
              </Form>
            )}
          </AuthConsumer>
        </Grid.Column>
      </Grid>
    );
  }
}
